import styled from 'styled-components'
import { AutofitIFrame } from '@ta-interaktiv/react-autofit-iframe'
import { ChartFrame } from 'components/ChartFrame'
import { useEffect, useState } from 'react'
import _trend_data from './wastewater_trend.json'
import { StackedBar } from 'components/StackedBar'
import { global_locales } from 'components/constants'
import { useElementSize, useWindowSize } from 'usehooks-ts'

const sort_array = [
  'sharply_falling',
  'falling',
  'stagnant',
  'rising',
  'sharply_rising',
]

const colors: { [key: string]: string } = {
  sharply_rising: '#E16D00',
  rising: '#F1BE8D',
  stagnant: '#E9E9E9',
  falling: '#A3C8AF',
  sharply_falling: '#479260',
}
const labelcolors: { [key: string]: string } = {
  sharply_rising: '#fff',
  rising: '#202346',
  stagnant: '#202346',
  falling: '#202346',
  sharply_falling: '#fff',
}

const locales = global_locales.wastewatertrend

export const TrendAlternative = ({
  colorMode,
  type = 'sars-cov-2',
  lang = 'de',
}: {
  colorMode: 'dark' | 'light' | undefined
  type: 'sars-cov-2' | 'influenza' | 'respiratory_syncytial_virus'
  lang: 'de' | 'fr'
}) => {
  const [endDate, setEndDate] = useState<Date>(new Date())
  const [trendData, setTrendData] = useState<any>(_trend_data)
  const [containerRef, { width, height }] = useElementSize()
  const windowSize = useWindowSize()
  const isMobile = windowSize.width < 712
  const ids: { [key: string]: string } = {
    covid: 'AeU7s',
    influenza: 'wj6QB/3',
    rsv: 'AlllL/6',
  }

  useEffect(() => {
    fetch(
      'https://storage.googleapis.com/ta-interaktiv/corona-dashboard-2023/version.json'
    )
      .then((a) => a.json())
      .then((a) => {
        setEndDate(a.date)
      })
  }, [])

  return (
    <TrendRoot ref={containerRef}>
      <ChartFrame
        lang={lang}
        title={locales[lang].title[type]}
        lead={locales[lang].lead}
        source={locales[lang].source}
        timestamp={
          <>
            {new Date(endDate).toLocaleDateString(lang + '-CH', {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
            })}
          </>
        }
      >
        <>
          {trendData[type].map(
            (virus: { type: string; [key: string]: number | string }) => {
              var entries = Object.entries(virus).filter((f) => f[0] !== 'type')
              var entrywidth = (width || 100) / entries.length

              return (
                <>
                  {trendData[type].length > 1 && (
                    <EntryContainer>
                      <EntryTitle>{locales[lang].virus[virus.type]}</EntryTitle>{' '}
                    </EntryContainer>
                  )}{' '}
                  <EntryContainer
                    style={{ flexWrap: isMobile ? 'wrap' : undefined }}
                  >
                    {entries.map(([key, value], i) => {
                      const elements = [...Array(Math.round(+value))]
                      return (
                        <Entry
                          style={{
                            width: isMobile ? '100%' : '20%',
                            height: isMobile ? '60px' : undefined,
                          }}
                        >
                          {locales[lang].step_labels[i]}
                          <DotContainer>
                            {elements.map((m) => {
                              return <Dot />
                            })}
                          </DotContainer>{' '}
                        </Entry>
                      )
                    })}
                  </EntryContainer>
                </>
              )
            }
          )}
        </>

        {/* <AutofitIFrame
          src={
            'https://datawrapper.dwcdn.net/' +
            ids[type] +
            '/?dark=' +
            String(colorMode === 'dark') +
            '&transparent=true'
          }
          height={50}
        /> */}
      </ChartFrame>
    </TrendRoot>
  )
}

const TrendRoot = styled.div``
const EntryContainer = styled.div`
  font-size: 14px;
  display: flex;
  margin-bottom: 30px;
`
const Entry = styled.div`
  box-sizing: border-box;
  border-right: 1px solid var(--sharetable-rank-border);
  border-left: 1px solid var(--sharetable-rank-border);
  margin-left: -1px;
  margin-bottom: 10px;
  text-align: center;
  @media screen and (max-width: 711px) {
    text-align: left;

    border: 0;
    border-top: 1px solid var(--sharetable-rank-border);
    border-bottom: 1px solid var(--sharetable-rank-border);
    margin: 0;
    margin-top: -1px;
  }
  width: 100px;
`
const DotContainer = styled.div`
  /*display: flex;
 flex-wrap: wrap; 
  justify-content: center;
  align-items: flex-start;
  gap: 0; */

  margin-top: 10px;
  padding-left: 20px;
  padding-right: 20px;

  line-height: 0;
  @media screen and (max-width: 711px) {
    padding: 0;
    margin-top: 0px;
  }
`
const dotsize = 15
const Dot = styled.div`
  display: inline-block;
  width: ${dotsize}px;
  height: ${dotsize}px;
  background-color: var(--text-color);
  border-radius: ${dotsize}px;
  margin: 2px;
`
const EntryTitle = styled.div`
  width: 100%;
  font-size: 16px;
  font-weight: 700;
`
